export default __webpack_public_path__ + "static/media/face_1_small.07d2e538.png";